import { json } from "@remix-run/node"

export async function loader() {
	return json({})
}

export default function AboutRoute() {
	return (
		<div className="w-full overflow-y-auto">
			<div className="mx-auto">
				<article className="prose mx-auto max-w-[60ch] px-8 py-16 font-serif text-[140%] dark:prose-invert md:px-16">
					<h1 className="text-mega">What is klipstack?</h1>

					<p>
						Read-it-later apps are great. They let you save articles for later, so you
						can read them when you have time. But I wish they were more collaborative.
					</p>

					<p>
						klipstack is a read-it-later service that not only lets you save articles
						and highlight the best parts. It also let you share the experience with
						others.
						<ul>
							<li>
								Imagine being able to share your favorite highlights and notes with
								your friends, or with the world.
							</li>
							<li>
								Imagine being able to see what your friends are reading and finding
								interesting.
							</li>
							<li>
								Imagine seeing what others are highlighting in the article you're
								reading.
							</li>
						</ul>
						That's what klipstack is all about.
					</p>

					<h2>Building klipstack</h2>

					<p>
						This is a young and ongoing journey. I saw this project as an opportunity to
						stretch my skills. It's given me (or will give me) a chance to dive into
						many aspects of development, from frontend to backend, devops and mobile
						apps. I've had to think about design and marketing too. And most of this is
						new to me, at least at this level of depth.
					</p>

					<p>
						I must mention that klipstack is still in its very early stages. Some
						features may be missing, under construction, or even a bit buggy. But I'm
						continually working on improving it, and I hope it will be as useful for you
						as it has been for me.
					</p>

					<p>
						I hope you'll give klipstack a try and share your feedback with me. Your
						insights will help shape its future development.
					</p>

					<p>Thank you for joining me on this journey. Happy reading!</p>

					<p>
						<a
							href="https://twitter.com/gnapse"
							target="_blank"
							rel="noopener noreferrer"
						>
							Ernesto
						</a>
					</p>
				</article>
			</div>
		</div>
	)
}
